/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoTraumaUpdateDTO
 */
export interface AssistitoTraumaUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaUpdateDTO
     */
    trauma?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaUpdateDTO
     */
    posizione?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssistitoTraumaUpdateDTO
     */
    dataTrauma?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaUpdateDTO
     */
    causa?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaUpdateDTO
     */
    dannoProvocato?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTraumaUpdateDTO
     */
    terapia?: string;
}

/**
 * Check if a given object implements the AssistitoTraumaUpdateDTO interface.
 */
export function instanceOfAssistitoTraumaUpdateDTO(value: object): value is AssistitoTraumaUpdateDTO {
    return true;
}

export function AssistitoTraumaUpdateDTOFromJSON(json: any): AssistitoTraumaUpdateDTO {
    return AssistitoTraumaUpdateDTOFromJSONTyped(json, false);
}

export function AssistitoTraumaUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoTraumaUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'trauma': json['trauma'] == null ? undefined : json['trauma'],
        'posizione': json['posizione'] == null ? undefined : json['posizione'],
        'dataTrauma': json['dataTrauma'] == null ? undefined : (new Date(json['dataTrauma'])),
        'causa': json['causa'] == null ? undefined : json['causa'],
        'dannoProvocato': json['dannoProvocato'] == null ? undefined : json['dannoProvocato'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
    };
}

export function AssistitoTraumaUpdateDTOToJSON(value?: AssistitoTraumaUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'trauma': value['trauma'],
        'posizione': value['posizione'],
        'dataTrauma': value['dataTrauma'] == null ? undefined : ((value['dataTrauma'] as any).toISOString()),
        'causa': value['causa'],
        'dannoProvocato': value['dannoProvocato'],
        'terapia': value['terapia'],
    };
}

